import { useState, useEffect } from 'react';

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIsMobile = () => {
      // Ekran genişliği kontrolü
      const isMobileByWidth = window.innerWidth <= 768;
      
      // User agent kontrolü
      const isMobileByUserAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
      
      // Touch desteği kontrolü
      const isMobileByTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
      
      // En az 2 kriter sağlanıyorsa mobil kabul et
      const mobileCriteria = [isMobileByWidth, isMobileByUserAgent, isMobileByTouch];
      const mobileScore = mobileCriteria.filter(Boolean).length;
      
      setIsMobile(mobileScore >= 2);
    };

    // İlk kontrol
    checkIsMobile();

    // Resize event listener
    const handleResize = () => {
      checkIsMobile();
    };

    window.addEventListener('resize', handleResize);
    
    // Cleanup
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return isMobile;
};
